/**
 * User preferences API service
 */

import apiClient from './api';
import { UserPreferences } from '../types';

export const preferencesApi = {
  /**
   * Get user preferences
   */
  async get(): Promise<UserPreferences> {
    const response = await apiClient.get<UserPreferences>('/preferences');
    return response.data;
  },

  /**
   * Update user preferences
   */
  async update(preferences: Partial<UserPreferences>): Promise<UserPreferences> {
    const response = await apiClient.put<UserPreferences>('/preferences', preferences);
    return response.data;
  },
};
